import { locItem } from '../../../model/game';
import { loc } from '../common';

export const WoodHouse1 = loc(
  1, 'WoodHouse1', ['Meadows'],
  { quantity: 20, terrainDelta: [0, 4], radius: [20, 8],
    customMusic: 'Music_MeadowsVillageFarm',
    items: [
      locItem('Beehive', 0.25),
      locItem('TreasureChest_meadows', 0.5),
      locItem('goblin_bed', 0.5),
    ],
  },
  'WoodHouse',
);
export const WoodHouse2 = loc(
  1, 'WoodHouse2', ['Meadows'],
  { quantity: 20, terrainDelta: [0, 4], radius: [20, 8],
    customMusic: 'Music_MeadowsVillageFarm',
    items: [
      locItem('Beehive', 0.25),
      locItem('TreasureChest_meadows_axe2', 0.5),
      locItem('goblin_bed', 0.5, 2),
    ],
  },
  'WoodHouse',
);
export const WoodHouse3 = loc(
  1, 'WoodHouse3', ['Meadows'],
  { quantity: 20, terrainDelta: [0, 4], radius: [20, 10],
    customMusic: 'Music_MeadowsVillageFarm',
    items: [
      locItem('Beehive', 0.25),
    ],
  },
  'WoodHouse',
);
export const WoodHouse4 = loc(
  1, 'WoodHouse4', ['Meadows'],
  { quantity: 20, terrainDelta: [0, 4], radius: [20, 8],
    customMusic: 'Music_MeadowsVillageFarm',
    items: [
      locItem('Beehive', 0.25),
    ],
  },
  'WoodHouse',
);
export const WoodHouse5 = loc(
  1, 'WoodHouse5', ['Meadows'],
  { quantity: 20, terrainDelta: [0, 4], radius: [20, 8],
    customMusic: 'Music_MeadowsVillageFarm',
    items: [
      locItem('Beehive', 0.25),
    ],
  },
  'WoodHouse',
);
export const WoodHouse6 = loc(
  1, 'WoodHouse6', ['Meadows'],
  { quantity: 20, terrainDelta: [0, 4], radius: [20, 8],
    customMusic: 'Music_MeadowsVillageFarm',
    items: [
      locItem('Beehive', 0.25),
      locItem('TreasureChest_meadows_axe1', 1),
    ],
  },
  'WoodHouse',
);
export const WoodHouse7 = loc(
  1, 'WoodHouse7', ['Meadows'],
  { quantity: 20, terrainDelta: [0, 4], radius: [20, 8],
    customMusic: 'Music_MeadowsVillageFarm',
    items: [
      locItem('Beehive', 0.25),
      locItem('TreasureChest_meadows', 0.5),
    ],
  },
  'WoodHouse',
);
export const WoodHouse8 = loc(
  1, 'WoodHouse8', ['Meadows'],
  { quantity: 20, terrainDelta: [0, 4], radius: [20, 10],
    customMusic: 'Music_MeadowsVillageFarm',
    items: [],
  },
  'WoodHouse',
);
export const WoodHouse9 = loc(
  1, 'WoodHouse9', ['Meadows'],
  { quantity: 20, terrainDelta: [0, 4], radius: [20, 8],
    customMusic: 'Music_MeadowsVillageFarm',
    items: [
      locItem('Beehive', 0.25),
      locItem('TreasureChest_meadows', 0.5),
    ],
  },
  'WoodHouse',
);
export const WoodHouse10 = loc(
  1, 'WoodHouse10', ['Meadows'],
  { quantity: 20, terrainDelta: [0, 4], radius: [20, 8],
    customMusic: 'Music_MeadowsVillageFarm',
    items: [
      locItem('Beehive', 0.25),
      locItem('TreasureChest_meadows', 0.5),
    ],
  },
  'WoodHouse',
);
export const WoodHouse11 = loc(
  1, 'WoodHouse11', ['Meadows'],
  { quantity: 20, terrainDelta: [0, 4], radius: [20, 8],
    customMusic: 'Music_MeadowsVillageFarm',
    items: [
      locItem('Beehive', 0.25),
      locItem('TreasureChest_meadows', 0.5),
    ],
  },
  'WoodHouse',
);
export const WoodHouse12 = loc(
  1, 'WoodHouse12', ['Meadows'],
  { quantity: 20, terrainDelta: [0, 4], radius: [20, 6],
    customMusic: 'Music_MeadowsVillageFarm',
    items: [
      locItem('TreasureChest_meadows', 0.5),
    ],
  },
  'WoodHouse',
);
export const WoodHouse13 = loc(
  1, 'WoodHouse13', ['Meadows'],
  { quantity: 20, terrainDelta: [0, 4], radius: [20, 9],
    customMusic: 'Music_MeadowsVillageFarm',
    items: [
      locItem('Beehive', 0.25),
      locItem('TreasureChest_meadows', 0.5),
    ],
  },
  'WoodHouse',
);
// WoodHouse 14 & 15 exists in locations scenes, but not in config, even as disabled